module.exports = __webpack_public_path__ + "static/img/02.d3bd36ac.png";